export default "__VITE_ASSET__15cff315__"